module.exports = "/video-roulette/img/green-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/green-ball.png
// module id = 2438
// module chunks = 10